import { compose, withProps } from 'recompose'

const enhance = compose(
  withProps(({ qualityCategoryScore, fullRatingsDisplayBool = false }) => {
    const scoreArr = qualityCategoryScore && qualityCategoryScore.split('/')
    const qualityScoreTextArr = fullRatingsDisplayBool
      ? ['quality rating from ', 'CMS']
      : ['', '']

    return {
      scoreArr,
      qualityScoreTextArr,
    }
  }),
)

export default enhance
